/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent as F, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import { searchProductsAsync } from "../../core/store/products/products.thunks";
import ProductsTable from "./ProductsTable";
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import SearchIcon from '@mui/icons-material/Search';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import TextField from '@mui/material/TextField';
import { updateProducts } from "../../core/store/products/products.slice";
import { LISTINGS, LOGIN, NEW } from "../../core/router/paths";
import Button from "../UI/Button/Button";
import { useAppDispatch } from "../../core/store/hooks";
import { IState } from "../../core/store/store";
import loadingGif from '../../images/loading.gif';
import { DialogTitle, IconButton, Link } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';


interface LocationState
{
  addNew?: boolean
  suppId?: number,
  swapDosingId?: number,
  query?: string
}

const ProductSearch: F = () =>
{
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const dispatch = useDispatch();
  const location = useLocation();

  const [locationState] = useState<LocationState | undefined>(location.state);

  const addToBundle = location.pathname.includes("listings/new");
  const products = useSelector((state: IState) => state.products.products);
  const lastSearchedProductId = useSelector((state: IState) => state.listings.productId);
  const username = useSelector((state: IState) => state.user.username);

  const [query, setQuery] = useState(searchParams.get("query") ?? locationState?.query);
  const [searchSubmitted, setSearchSubmitted] = useState(false);

  useEffect(() =>
  {
    if(!query && !locationState?.suppId)
      return;

    submitSearch();
  }, []);

  async function submitSearch(q = query)
  {
    setSearchSubmitted(true);
    dispatch(updateProducts(undefined));

    if(!q && !locationState?.suppId)
    {
      setSearchParams({ });
      return dispatch(updateProducts([]));
    }

    await appDispatch(searchProductsAsync(q, locationState?.suppId));
    setSearchParams({ query: String(q) });
  }

  function handleFormSubmit(event: React.FormEvent<HTMLFormElement>)
  {
    submitSearch();
    event.preventDefault();
  }

  const handleProductClick = (productId: number) =>
  {
    if(addToBundle)
    {
      navigate("../", { state: { ...locationState, bundleProductId: productId }, relative: "path" });
      return;
    }

    navigate(productId + "/" + LISTINGS, { state: {
      retrieveListings: productId !== lastSearchedProductId,
      swapDosingId: locationState?.swapDosingId,
      query }, relative: "path" });
  };

  const suggestions = [
    "B12", "Zinc", "Curcumin", "Lemon Balm", "L-Lysine", "Cat's Claw", "Licorice", "Goldenseal", "Micro-C"];

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      PaperProps={{ sx: { p: '15px' }}}
      open={true}
      onClose={() => navigate("../", { relative: 'path' })}>
      {addToBundle ?
        <IconButton
          disableRipple
          onClick={() => navigate(-1)}
          sx={{ display: 'inline-flex', float: 'left', width: '80px' }}>
          <ArrowBackIosNewIcon sx={{ mt: 3, ml: 1, fontSize: 65, color: 'lightGray' }}/>
        </IconButton> :
        <></>}
      <DialogTitle sx={{ ml: 3, fontSize: '30px' }}>Search for a product</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ width: '100%' }}>
          <Stack direction='row'>
            <form onSubmit={handleFormSubmit} style={{ marginRight: 12 }}>
              <TextField
                id='Search'
                size='small'
                value={query}
                onChange={event => setQuery(event.target.value)}
                style={{ width: '400px', display: 'flex' }}
                placeholder='Search for a product'
                inputProps={{ style: {
                  padding: 10,
                  paddingLeft: 16,
                  paddingRight: 6,
                  fontSize: 14 }}}
                autoFocus/>
            </form>
            <Button
              id='Search'
              size='medium'
              startIcon={<SearchIcon />}
              onClick={submitSearch}
              label='Search'/>
            {products?.length ?
              <Button
                id='Clear'
                size='medium'
                color='error'
                startIcon={<RemoveCircleIcon />}
                onClick={() =>
                {
                  setQuery("");
                  setSearchParams({ });
                  setSearchSubmitted(false);
                  dispatch(updateProducts(undefined));
                }}
                label='Clear'/> :
              <></>}
          </Stack>

          {!products?.length ?
            <Stack spacing={1}>
              <Typography variant='body2'>
                {"🔎 Suggestions:"}
              </Typography>
              <Typography variant='body2' marginTop={-5}>
                {suggestions.map(q =>
                  <Link
                    style={{ cursor: 'pointer', marginBlock: 3, paddingInline: 7 }}
                    variant='body2'
                    noWrap
                    onClick={() =>
                    {
                      setQuery(q);
                      submitSearch(q);
                    }}>
                    {q}
                  </Link>)}
              </Typography>
            </Stack> :
            <></>}

          {(searchSubmitted && products && !products.length) ?
            <>
              <Typography variant='body2'>
                {"No products found for '" + query + "'."}
              </Typography>
              <Stack direction='row'>
                <Link
                  variant='body2'
                  underline='hover'
                  style={{ cursor: 'pointer' }}
                  onClick={username ? () => navigate(NEW) : () => navigate(LOGIN)} >
                  <i>{username ? "Add a new product" : "Log in to add a new product"}</i>
                </Link>
                <></>
              </Stack>
            </> :
            <></>}

          {(() =>
          {
            if(products?.length)
            {
              return (
                <ProductsTable
                  addNew={locationState?.addNew}
                  handleProductClick={handleProductClick}/>);
            }
            else if(searchSubmitted && !products)
            {
              return (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <img src={loadingGif} width='100px'/>
                </Box>);
            }
            else if(!searchSubmitted)
            {
              return <></>;
            }
          })()}
        </Stack>
      </DialogContent>
    </Dialog>);
};

export default ProductSearch;
